import { IExperiment } from '../../../api/experiments';

export const LAYOUT_SUBSCRIBE_ADDRESS = 'layout_subscribe_address';

export enum ELayoutSubscribeAddressGroups {
  A = 0,
  B = 1,
}

export function isLayoutSubscribeAddress(experiments: IExperiment[] | undefined) {
  if (!experiments) {
    return false;
  }

  const exp = experiments.find(experiment => experiment.name === LAYOUT_SUBSCRIBE_ADDRESS);

  return !!(exp && exp.abGroup === ELayoutSubscribeAddressGroups.B);
}
